














































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import Requester from '../../requester';

import { Gestacao } from '../../../../back/src/entity/Gestacao';
import {
  GestacaoFinalizadaAlterarFormData, GestacaoFinalizarFormData, TipoParto,
} from '../../../../back/src/types';
import {
  localPartoItens,
  localPartoLowerValues,
  partoAguaItens,
  posicoesPartoItens,
  sexoBebeItensFinalizar,
  tipoPartoItens,
  rupturaBolsaItens,
  periodoExpulsivoItens,
  manobraDequitacaoItens,
  sangramentoPosPartoItens,
  indicacaoCesareaItens,
  hppQuantidadeItens,
  clampeamentoItens,
  amamentacaoItens,
  encaminhamentoRnItens,
} from '../../utils/constants';
import { Paciente } from '../../../../back/src/entity/Paciente';
import Confirmar from '../Confirmar.vue';
import { Parto } from '../../../../back/src/entity/Parto';

export default Vue.extend({
  name: 'GestacoesFinalizarForm',
  components: {
    Confirmar,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
      required: true,
    },
    gestacao: {
      type: Object as () => Gestacao,
      required: true,
    },
    alterarGestacaoFinalizada: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: {
        submit: false,
      },
      valid: false,
      menuDataParto: false,
      laceracao: null,
      form: {
        rupturaBolsa: null,
        tipoParto: null,
        periodoExpulsivo: null,
        sangramentoPosParto: null,
        manobraDequitacao: null,
        partoAgua: null,
        posicaoParto: null,
        posicaoPartoOutra: null,
        tempoDequitacao: null,
        indicacaoCesarea: null,
        indicacaoCesareaOutro: null,
        dataParto: null,
        horarioParto: null,
        igAbortoSemanas: null,
        laceracao: null,
        sutura: null,
        ocorrenciaAnalgesia: null,
        ocorrenciaForceps: null,
        ocorrenciaHpp: null,
        hppQuantidade: null,
        ocorrenciaInduzido: null,
        ocorrenciaVacuo: null,
        ocorrenciaRuptura: null,
        ocorrenciaOcitocina: null,
        ocorrenciaEpisiotomia: null,
        ocorrenciaKristellerPressaoFundica: null,
        ocorrenciaUti: null,
        ocorrenciaTransfusao: null,
        ocorrenciaDistociaOmbros: null,
        medico: null,
        pediatra: null,
        doula: null,
        fotografa: null,
        localParto: null,
        localPartoOutro: null,
        observacoes: null,
        // Bebe(s)
        nome1: null,
        sexo1: null,
        peso1: null,
        apgar1: [null, null, null],
        clampeamento1: null,
        contato1: null,
        contato1Justificativa: null,
        amamentacao1: null,
        amamentacao1Outro: null,
        intercorrenciasRn1: null,
        encaminhamentoRn1: null,
        encaminhamentoRn1Justificativa: null,
        nome2: null,
        sexo2: null,
        peso2: null,
        apgar2: [null, null, null],
        clampeamento2: null,
        contato2: null,
        contato2Justificativa: null,
        amamentacao2: null,
        amamentacao2Outro: null,
        intercorrenciasRn2: null,
        encaminhamentoRn2: null,
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório.',
        ],
        notNull: [
          (v: string) => v !== null || 'Campo obrigatório.',
        ],
        hora: [
          (v: string) => {
            const timePattern: RegExp = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
            return (!v || (v && timePattern.test(v))) || 'Horário inválido';
          },
        ],
      },
      items: {
        sexoBebe: sexoBebeItensFinalizar,
        tipoParto: tipoPartoItens,
        grausLaceracao: [
          { value: 1, text: '1' },
          { value: 2, text: '2' },
          { value: 3, text: '3' },
          { value: 4, text: '4' },
        ],
        localParto: localPartoItens,
        partoAgua: partoAguaItens,
        posicaoParto: posicoesPartoItens,
        rupturaBolsa: rupturaBolsaItens,
        periodoExpulsivo: periodoExpulsivoItens,
        manobraDequitacao: manobraDequitacaoItens,
        sangramentoPosParto: sangramentoPosPartoItens,
        indicacaoCesarea: indicacaoCesareaItens,
        hppQuantidade: hppQuantidadeItens,
        clampeamento: clampeamentoItens,
        amamentacao: amamentacaoItens,
        encaminhamentoRn: encaminhamentoRnItens,
      },
      TipoParto,
    };
  },
  computed: {
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    vColClass(): string {
      return 'pt-1 pb-2';
    },
    vColLabelClass(): string {
      return 'pt-1 pb-2 mb-1';
    },
    actionsClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex justify-space-between pt-0 pb-2';
      }
      return 'd-flex justify-end pt-0 pb-2';
    },
    rulesPartoNormalOuCesarea(): any[] {
      if (this.form.tipoParto === TipoParto.N || this.form.tipoParto === TipoParto.C) {
        return this.rules.required;
      }
      return [];
    },
    rulesAborto(): any[] {
      if (this.form.tipoParto === TipoParto.A) {
        return this.rules.required;
      }
      return [];
    },
    rulesPartoNormal(): any[] {
      if (this.form.tipoParto === TipoParto.N) {
        return this.rules.required;
      }
      return [];
    },
    rulesPartoCesaria(): any[] {
      if (this.form.tipoParto === TipoParto.C) {
        return this.rules.required;
      }
      return [];
    },
    rulesHorarioParto(): any[] {
      if (this.form.tipoParto === TipoParto.N || this.form.tipoParto === TipoParto.C) {
        return _.concat(this.rules.required, this.rules.hora);
      }
      return this.rules.hora;
    },
    dataPartoFormatada(): string {
      if (this.form.dataParto) {
        const momentDataParto = moment(this.form.dataParto);
        if (momentDataParto.isValid()) {
          return momentDataParto.format('DD/MM/YYYY');
        }
      }
      return '';
    },
    datetimeParto(): Date | null {
      const momentDatetimeParto = moment(`${this.form.dataParto} ${this.form.horarioParto}`);
      if (!momentDatetimeParto.isValid()) {
        return null;
      }
      return momentDatetimeParto.toDate();
    },
    formGestacaoFinalizar(): Vue & { validate: () => boolean, resetValidation: () => void } {
      return this.$refs.formGestacaoFinalizar as Vue & {
        validate: () => boolean,
        resetValidation: () => void
      };
    },
  },
  mounted() {
    this.preencheForm();
  },
  methods: {
    // eslint-disable-next-line func-names
    desfazerDebounce: _.debounce(async function () { await this.desfazer(); }, 200),
    async desfazer() {
      if (await this.confirmar.open(
        'Desfazer edição',
        'Tem certeza que deseja desfazer a edição?\nOs dados alterados serão perdidos.',
      ) === false) {
        return;
      }
      this.$emit('desfazer-edicao');
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading.submit = true;
      if (!this.formGestacaoFinalizar.validate()) {
        this.loading.submit = false;
        return;
      }
      const formData: GestacaoFinalizarFormData | GestacaoFinalizadaAlterarFormData = this
        .montaFormData();
      let response;
      let event = 'finaliza-gestacao';
      let msg = 'Gestação finalizada com sucesso!';
      try {
        if (this.alterarGestacaoFinalizada) {
          // ALTERANDO
          event = 'gestacao-finalizada-atualizada';
          msg = 'Dados atualizados com sucesso';
          response = await Requester.gestacao.alteraGestacaoFinalizada(
            this.gestacao.id,
            formData as GestacaoFinalizadaAlterarFormData,
          );
        } else {
          // FINALIZANDO
          response = await Requester.gestacao.finalizaGestacao(formData);
        }
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$emit(event, response.data);
          this.$root.$emit('avisoSnackbar', { color: 'success', text: msg });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
    montaFormData(): GestacaoFinalizarFormData | GestacaoFinalizadaAlterarFormData {
      const pn: boolean = this.form.tipoParto === TipoParto.N;
      const pc: boolean = this.form.tipoParto === TipoParto.C;
      const pa: boolean = this.form.tipoParto === TipoParto.A;

      // coisas de cesarea
      let indicacaoCesarea: string | null = null;
      if (pc) {
        indicacaoCesarea = this.form.indicacaoCesarea === 'Outro'
          ? this.form.indicacaoCesareaOutro
          : this.form.indicacaoCesarea;
      }
      // coisas de parto normal
      let laceracao: number | null = null;
      let sutura: boolean | null = null;
      let posicaoParto: string | null = null;
      if (pn) {
        laceracao = this.laceracao ? Number(this.form.laceracao) : 0;
        sutura = this.laceracao ? this.form.sutura : null;
        posicaoParto = this.form.posicaoParto === 'Outra'
          ? this.form.posicaoPartoOutra
          : this.form.posicaoParto;
      }

      // coisas do bebe 1
      let amamentacao1: string | null = null;
      let encaminhamentoRn1Justificativa: string | null = null;
      // coisas do bebe 2
      let amamentacao2: string | null = null;
      let encaminhamentoRn2Justificativa: string | null = null;
      if (pn || pc) {
        amamentacao1 = this.form.amamentacao1 === 'Outro' ? this.form.amamentacao1Outro : this.form.amamentacao1;
        encaminhamentoRn1Justificativa = this.form.encaminhamentoRn1 !== 'Alojamento Conjunto'
          ? this.form.encaminhamentoRn1Justificativa : null;
        if (this.gestacao.gestacao_gemelar) {
          amamentacao2 = this.form.amamentacao2 === 'Outro' ? this.form.amamentacao2Outro : this.form.amamentacao2;
          encaminhamentoRn2Justificativa = this.form.encaminhamentoRn2 !== 'Alojamento Conjunto'
            ? this.form.encaminhamentoRn2Justificativa : null;
        }
      }

      const formData: GestacaoFinalizarFormData | GestacaoFinalizadaAlterarFormData = {
        Gestacao: {
          id: this.gestacao.id,
          medico: this.form.medico,
          pediatra: this.form.pediatra,
          doula: this.form.doula,
          fotografa: this.form.fotografa,
          local_parto: this.form.localParto === 'outro'
            ? this.form.localPartoOutro
            : this.form.localParto,
          nome1: pa ? null : this.form.nome1,
          sexo1: pa ? null : this.form.sexo1,
          nome2: !pa && this.gestacao.gestacao_gemelar ? this.form.nome2 : null,
          sexo2: !pa && this.gestacao.gestacao_gemelar ? this.form.sexo2 : null,
        },
        Parto: {
          paciente_id: this.paciente.id,
          tipo_parto: this.form.tipoParto,
          data_parto: pa ? null : this.datetimeParto,
          ruptura_bolsa: pa ? null : this.form.rupturaBolsa,
          duracao_periodo_expulsivo: pa ? null : this.form.periodoExpulsivo,
          sangramento_pos_parto: pa ? null : this.form.sangramentoPosParto,
          observacoes: this.form.observacoes,
          // PARTO NORMAL
          parto_na_agua: pn ? this.form.partoAgua : null,
          posicao_parto: pn ? posicaoParto : null,
          tempo_dequitacao: pn ? this.form.tempoDequitacao : null,
          manobra_dequitacao: pn ? this.form.manobraDequitacao : null,
          laceracao,
          sutura,
          // CESAREA
          indicacao_cesarea: indicacaoCesarea,
          // ABORTO
          ig_aborto_semanas: this.form.igAbortoSemanas,
          // OCORRENCIAS
          ocorrencia_hpp: this.form.ocorrenciaHpp,
          hpp_quantidade: this.form.ocorrenciaHpp ? this.form.hppQuantidade : null,
          ocorrencia_induzido: this.form.ocorrenciaInduzido,
          ocorrencia_analgesia: this.form.ocorrenciaAnalgesia,
          ocorrencia_vacuo: this.form.ocorrenciaVacuo,
          ocorrencia_forceps: this.form.ocorrenciaForceps,
          ocorrencia_ruptura: this.form.ocorrenciaRuptura,
          ocorrencia_ocitocina: this.form.ocorrenciaOcitocina,
          ocorrencia_episiotomia: this.form.ocorrenciaEpisiotomia,
          ocorrencia_kristeller_pressao_fundica: this.form.ocorrenciaKristellerPressaoFundica,
          ocorrencia_uti_materna: this.form.ocorrenciaUti,
          ocorrencia_transfusao: this.form.ocorrenciaTransfusao,
          ocorrencia_distocia_ombros: this.form.ocorrenciaDistociaOmbros,
          // BEBE 1
          peso1_gramas: pa ? null : this.form.peso1,
          apgar1_1: pa ? null : this.form.apgar1[0],
          apgar1_2: pa ? null : this.form.apgar1[1],
          apgar1_3: pa ? null : this.form.apgar1[2] || null,
          clampeamento1: pa ? null : this.form.clampeamento1,
          contato_pele1: pa ? null : this.form.contato1,
          contato_pele1_justificativa: this.form.contato1 ? null : this.form.contato1Justificativa,
          amamentacao1,
          encaminhamento1: pa ? null : this.form.encaminhamentoRn1,
          encaminhamento1_justificativa: pa ? null : encaminhamentoRn1Justificativa,
          intercorrencias1: pa ? null : this.form.intercorrenciasRn1,
          // BEBE 2
          peso2_gramas: (!pa && this.gestacao.gestacao_gemelar) ? this.form.peso2 : null,
          apgar2_1: (!pa && this.gestacao.gestacao_gemelar) ? this.form.apgar2[0] : null,
          apgar2_2: (!pa && this.gestacao.gestacao_gemelar) ? this.form.apgar2[1] : null,
          apgar2_3: (!pa && this.gestacao.gestacao_gemelar) ? this.form.apgar2[2] : null,
          clampeamento2: (!pa && this.gestacao.gestacao_gemelar) ? this.form.clampeamento2 : null,
          contato_pele2: (!pa && this.gestacao.gestacao_gemelar) ? this.form.contato2 : null,
          contato_pele2_justificativa: !pa && this.gestacao.gestacao_gemelar && !this.form.contato2
            ? this.form.contato2Justificativa : null,
          amamentacao2,
          encaminhamento2: (!pa && this.gestacao.gestacao_gemelar)
            ? this.form.encaminhamentoRn2 : null,
          encaminhamento2_justificativa: encaminhamentoRn2Justificativa,
          intercorrencias2: (!pa && this.gestacao.gestacao_gemelar)
            ? this.form.intercorrenciasRn2 : null,
        },
      };
      if (this.alterarGestacaoFinalizada) {
        (formData as GestacaoFinalizadaAlterarFormData).Parto.id = this.gestacao.parto.id;
      }
      return formData;
    },
    preencheForm() {
      const sexosFinalizar: string[] = _.map(sexoBebeItensFinalizar, el => el.value);
      if (this.gestacao) {
        // DADOS DE GESTAÇÃO
        this.form.nome1 = this.gestacao.nome1;
        this.form.sexo1 = sexosFinalizar.includes(this.gestacao.sexo1) ? this.gestacao.sexo1 : null;
        this.form.nome2 = this.gestacao.nome2;
        this.form.sexo2 = sexosFinalizar.includes(this.gestacao.sexo2) ? this.gestacao.sexo2 : null;
        this.form.medico = this.gestacao.medico;
        this.form.pediatra = this.gestacao.pediatra;
        this.form.doula = this.gestacao.doula;
        this.form.fotografa = this.gestacao.fotografa;
        const localParto = _.get(this.gestacao, 'local_parto', '');
        const local = localParto ? _.get(localPartoLowerValues, _.toLower(localParto.trim()), '') : '';
        this.form.localParto = localParto ? local || 'outro' : null;
        this.form.localPartoOutro = localParto && !local ? localParto : null;
      }
      if (this.gestacao.parto) {
        // eslint-disable-next-line prefer-destructuring
        const parto: Parto = this.gestacao.parto;
        this.form.tipoParto = parto.tipo_parto;
        if (parto.tipo_parto !== TipoParto.A) {
          // PARTOS
          this.form.dataParto = moment(parto.data_parto as Date).format('YYYY-MM-DD');
          this.form.horarioParto = moment(parto.data_parto as Date).format('HH:mm');
          this.form.rupturaBolsa = parto.ruptura_bolsa;
          this.form.periodoExpulsivo = parto.duracao_periodo_expulsivo;
          this.form.sangramentoPosParto = parto.sangramento_pos_parto;
          this.form.observacoes = parto.observacoes;
          if (parto.tipo_parto === TipoParto.N) {
            // PARTO NORMAL
            this.form.partoAgua = parto.parto_na_agua;
            const posicaoPartoItem = _.find(
              posicoesPartoItens,
              el => el.value === parto.posicao_parto,
            );
            this.form.posicaoParto = posicaoPartoItem ? posicaoPartoItem.value : 'Outra';
            this.form.posicaoPartoOutra = this.form.posicaoParto !== 'Outra' ? null : parto.posicao_parto;
            this.form.tempoDequitacao = parto.tempo_dequitacao;
            this.form.manobraDequitacao = parto.manobra_dequitacao;
            this.laceracao = !!parto.laceracao;
            this.form.laceracao = parto.laceracao;
            this.form.sutura = !!parto.sutura;
          }
          if (parto.tipo_parto === TipoParto.C) {
            // PARTO CESAREA
            const indicacaoCesareaItem = _.find(
              indicacaoCesareaItens,
              el => el.value === parto.indicacao_cesarea,
            );
            this.form.indicacaoCesarea = indicacaoCesareaItem ? indicacaoCesareaItem.value : 'Outro';
            this.form.indicacaoCesareaOutro = this.form.indicacaoCesarea !== 'Outro' ? null : parto.indicacao_cesarea;
          }
          // OCORRENCIAS
          this.form.ocorrenciaAnalgesia = !!parto.ocorrencia_analgesia;
          this.form.ocorrenciaForceps = !!parto.ocorrencia_forceps;
          this.form.ocorrenciaHpp = !!parto.ocorrencia_hpp;
          this.form.hppQuantidade = parto.ocorrencia_hpp ? parto.hpp_quantidade : null;
          this.form.ocorrenciaInduzido = !!parto.ocorrencia_induzido;
          this.form.ocorrenciaVacuo = !!parto.ocorrencia_vacuo;
          this.form.ocorrenciaRuptura = !!parto.ocorrencia_ruptura;
          this.form.ocorrenciaOcitocina = !!parto.ocorrencia_ocitocina;
          this.form.ocorrenciaEpisiotomia = !!parto.ocorrencia_episiotomia;
          this.form.ocorrenciaKristellerPressaoFundica = !!parto
            .ocorrencia_kristeller_pressao_fundica;
          this.form.ocorrenciaUti = !!parto.ocorrencia_uti_materna;
          this.form.ocorrenciaTransfusao = !!parto.ocorrencia_transfusao;
          this.form.ocorrenciaDistociaOmbros = !!parto.ocorrencia_distocia_ombros;
          // BEBE 1
          this.form.peso1 = parto.peso1_gramas;
          this.form.apgar1[0] = parto.apgar1_1;
          this.form.apgar1[1] = parto.apgar1_2;
          this.form.apgar1[2] = parto.apgar1_3;
          this.form.clampeamento1 = parto.clampeamento1;
          this.form.contato1 = !!parto.contato_pele1;
          this.form.contato1Justificativa = parto.contato_pele1_justificativa;
          const amamentacao1Item = _.find(
            amamentacaoItens,
            el => el.value === parto.amamentacao1,
          );
          this.form.amamentacao1 = amamentacao1Item ? amamentacao1Item.value : 'Outro';
          this.form.amamentacao1Outro = this.form.amamentacao1 !== 'Outro' ? null : parto.amamentacao1;
          this.form.intercorrenciasRn1 = parto.intercorrencias1;
          this.form.encaminhamentoRn1 = parto.encaminhamento1;
          this.form.encaminhamentoRn1Justificativa = parto.encaminhamento1_justificativa;
          if (this.gestacao.gestacao_gemelar) {
            this.form.peso2 = parto.peso2_gramas;
            this.form.apgar2[0] = parto.apgar2_1;
            this.form.apgar2[1] = parto.apgar2_2;
            this.form.apgar2[2] = parto.apgar2_3;
            this.form.clampeamento2 = parto.clampeamento2;
            this.form.contato2 = !!parto.contato_pele2;
            this.form.contato2Justificativa = parto.contato_pele2_justificativa;
            const amamentacao2Item = _.find(
              amamentacaoItens,
              el => el.value === parto.amamentacao2,
            );
            this.form.amamentacao2 = amamentacao2Item ? amamentacao2Item.value : 'Outro';
            this.form.amamentacao2Outro = this.form.amamentacao2 !== 'Outro' ? null : parto.amamentacao2;
            this.form.intercorrenciasRn2 = parto.intercorrencias2;
            this.form.encaminhamentoRn2 = parto.encaminhamento2;
            this.form.encaminhamentoRn2Justificativa = parto.encaminhamento2_justificativa;
          }
        } else {
          // ABORTO
          this.form.igAbortoSemanas = parto.ig_aborto_semanas;
        }
      }
    },
  },
});
